"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrate = exports.preloadWithAPI = exports.PRELOAD_MAX_AGE = void 0;
const fp_1 = require("lodash/fp");
const js_preload_data_1 = require("./js-preload-data");
const utils_1 = require("./utils");
const validator_app_1 = require("./validator-app");
exports.PRELOAD_MAX_AGE = 15 * 60 * 1000; // 15min
function preloadWithAPI(currency, getAPI) {
    return __awaiter(this, void 0, void 0, function* () {
        const api = yield getAPI();
        const cluster = (0, utils_1.clusterByCurrencyId)(currency.id);
        const validators = cluster === "devnet" ? yield loadDevnetValidators(api) : yield (0, validator_app_1.getValidators)(cluster);
        const data = {
            version: "1",
            validatorsWithMeta: [],
            validators: cluster === "mainnet-beta" ? preprocessMainnetValidators(validators) : validators,
        };
        (0, js_preload_data_1.setSolanaPreloadData)(data, currency);
        return data;
    });
}
exports.preloadWithAPI = preloadWithAPI;
function preprocessMainnetValidators(validators) {
    return (0, fp_1.flow)(() => validators, utils_1.profitableValidators, utils_1.ledgerFirstValidators)();
}
function loadDevnetValidators(api) {
    return __awaiter(this, void 0, void 0, function* () {
        const voteAccs = yield api.getVoteAccounts();
        const validators = voteAccs.current.map(acc => ({
            activeStake: acc.activatedStake,
            commission: acc.commission,
            totalScore: 0,
            voteAccount: acc.votePubkey,
        }));
        return validators;
    });
}
function hydrate(data, currency) {
    if (data === undefined) {
        return;
    }
    switch (data.version) {
        case "1":
            hydrateV1(data, currency);
            return;
        case "2":
            throw new Error("version 2 for now exists only to support discriminated union");
        default:
            return (0, utils_1.assertUnreachable)(data);
    }
}
exports.hydrate = hydrate;
function hydrateV1(data, currency) {
    (0, js_preload_data_1.setSolanaPreloadData)(data, currency);
}
//# sourceMappingURL=js-preload.js.map